import React from "react";

const UserPermissionContext = React.createContext();

export default UserPermissionContext;
